import { useMemo } from "react";
import { cn } from "@/lib/utils";
import { sanitizeHtml } from "@/lib/sanitize";

interface SanitizedHtmlProps {
  html: string;
  className?: string;
}

/**
 * Render vendor-authored HTML (What's New) safely. The HTML is DOMPurify-
 * sanitized here at render time as well as before persist, so a value that
 * reached the DB by any other path still can't inject script/handlers.
 */
export function SanitizedHtml({ html, className }: SanitizedHtmlProps) {
  const clean = useMemo(() => sanitizeHtml(html), [html]);
  return (
    <div
      className={cn("prose prose-sm dark:prose-invert max-w-none", className)}
      // Safe: `clean` is DOMPurify output with a strict tag/attr allow-list.
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
